import { useFormikContext } from 'formik';
import { HiOutlineCheck, HiOutlineX } from 'react-icons/hi';
import { Button } from 'ui/components/common';
import { Input } from 'ui/components/form';
import { SIZE } from 'utils/constants';

import { SET_INVITE_PASSWORD_FORM } from './schema';

const CHECKITEMS = [
  {
    isChecked: (val: string) => val.length >= 8,
    label: 'At least 8 characters long',
  },
  {
    isChecked: (val: string) => /.*[a-z].*/.test(val),
    label: 'One lowercase character',
  },
  {
    isChecked: (val: string) => /.*[A-Z].*/.test(val),
    label: 'One uppercase character',
  },
  {
    isChecked: (val: string) =>
      // eslint-disable-next-line no-useless-escape
      /[\s!@#$%^&*()_+{}\[\]:;<>,.?~\\-\d]/g.test(val),
    label: 'One number, symbol, or whitespace character',
  },
];

const SetInvitePasswordForm = () => {
  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
  } = useFormikContext<SET_INVITE_PASSWORD_FORM>();

  return (
    <form onSubmit={handleSubmit} className="mt-5">
      <Input
        className="mb-3 w-full"
        type="password"
        name="password"
        size={SIZE.Large}
        textType={errors.password && touched.password ? 'danger' : 'default'}
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.password}
        placeholder="Password"
        disabled={isSubmitting}
      />
      <Input
        className="w-full"
        type="password"
        name="passwordConfirmation"
        size={SIZE.Large}
        textType={
          errors.passwordConfirmation && touched.passwordConfirmation
            ? 'danger'
            : 'default'
        }
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.passwordConfirmation}
        placeholder="Confirm Password"
        subText={
          errors.passwordConfirmation && touched.passwordConfirmation
            ? errors.passwordConfirmation
            : undefined
        }
        disabled={isSubmitting}
      />
      <div className="mt-6 space-y-3">
        {CHECKITEMS.map(({ label, isChecked }) => (
          <div className="flex items-center gap-x-3" key={label}>
            {isChecked(values.password) ? (
              <HiOutlineCheck className="h-5 w-5 text-primary-base" />
            ) : (
              <HiOutlineX className="h-5 w-5 text-danger-base" />
            )}
            <p className="text-sm">{label}</p>
          </div>
        ))}
      </div>
      <Button
        type="submit"
        className="mt-6 w-full font-semibold"
        size="lg"
        label="SAVE"
        disabled={
          isSubmitting ||
          !!Object.keys(errors).length ||
          Object.keys(touched).length === 0
        }
      />
    </form>
  );
};

export default SetInvitePasswordForm;
